<template>
  <div id="contenedor-editar-convenio-modificatorio">
    <v-form
      v-model="formularioValido"
      ref="editarContratoConvenioModificatorio">
      <v-card>
        <v-card-title class="secondary--text">
          Editar convenio
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row align="center">
            <custom-date-picker
              cols="12"
              md="5"
              v-model="contratoConvenioModificatorio.fecha"
              label="Fecha"
              :rules="[mixReglas.requerido]">
            </custom-date-picker>
            <custom-select
              cols="12"
              md="7"
              v-model="contratoConvenioModificatorio.tipo"
              label="Tipo de Convenio Modificatorio"
              :items="tiposConvenios"
              disabled>
            </custom-select>
            <custom-text-field
              cols="12"
              v-model="contratoConvenioModificatorio.numero"
              label="Número"
              :rules="[mixReglas.requerido]">
            </custom-text-field>
            <v-col
              v-if="isPlazo"
              cols="12"
              class="pa-1">
              <v-card style="border: 1px solid #6A83B5;" flat class="rounded-lg">
                <v-card-title>Nuevo Plazo</v-card-title>
                <v-card-text>
                  <v-row align="center">
                    <custom-date-picker
                      cols="12"
                      md="6"
                      v-model="contratoConvenioModificatorio.fechaInicio"
                      label="Fecha Inicio"
                      :rules="[mixReglas.requerido]">
                    </custom-date-picker>
                    <custom-date-picker
                      cols="12"
                      md="6"
                      v-model="contratoConvenioModificatorio.fechaTermino"
                      label="Fecha Termino"
                      :rules="[mixReglas.requerido]">
                    </custom-date-picker>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col
              v-if="isMeta"
              cols="12"
              class="pa-1">
              <v-card style="border: 1px solid #6A83B5;" flat class="rounded-lg">
                <v-card-title>Nueva Meta</v-card-title>
                <v-card-text>
                  <v-row align="center">
                    <custom-text-field
                      cols="12"
                      v-model="contratoConvenioModificatorio.objeto"
                      label="Meta"
                      key="metaContrato"
                      :rules="[mixReglas.requerido]">
                    </custom-text-field>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col
              v-if="isMonto"
              cols="12"
              class="pa-1">
              <v-card style="border: 1px solid #6A83B5;" flat class="rounded-lg">
                <v-card-title>Datos Monto</v-card-title>
                <v-card-text>
                  <v-row>
                    <template
                      v-if="contrato.esObraFinanciada">
                      <custom-text-field-green
                        cols="6"
                        v-model.number="contratoConvenioModificatorio.importeCostoDirecto"
                        label="Importe Costo Directo"
                        es-dinero
                        prefix="$"
                        :rules="[mixReglas.requerido]"
                        @keyup="calcularCostosDeFinanciamiento">
                      </custom-text-field-green>
                      <custom-text-field-green
                        cols="6"
                        v-model.number="contratoConvenioModificatorio.importeCostoIndirectos"
                        label="Importe Indirectos"
                        es-dinero
                        prefix="$"
                        :rules="[mixReglas.requerido]"
                        @keyup="sumarImportesFinanciado">
                      </custom-text-field-green>
                      <custom-text-field-green
                        cols="6"
                        v-model.number="contratoConvenioModificatorio.importeUtilidad"
                        label="Importe Utilidad"
                        es-dinero
                        prefix="$"
                        :rules="[mixReglas.requerido]"
                        @keyup="sumarImportesFinanciado">
                      </custom-text-field-green>
                      <custom-text-field-green
                        cols="6"
                        v-model.number="contratoConvenioModificatorio.importeCargosAdicionales"
                        label="Importe Adicionales"
                        es-dinero
                        prefix="$"
                        :rules="[mixReglas.requerido]"
                        @keyup="sumarImportesFinanciado">
                      </custom-text-field-green>
                      <custom-text-field-green
                        cols="6"
                        v-model.number="contratoConvenioModificatorio.importeCostoFinanciero"
                        label="Importe C. Financiero"
                        es-dinero
                        prefix="$"
                        :rules="[mixReglas.requerido]"
                        @keyup="sumarImportesFinanciado">
                      </custom-text-field-green>
                      <v-col
                        cols="12">
                        <v-divider></v-divider>
                      </v-col>
                    </template>
                    <custom-text-field-green
                      cols="9"
                      v-model.number="contratoConvenioModificatorio.importe"
                      label="Importe"
                      es-dinero
                      prefix="$"
                      :rules="[mixReglas.requerido]"
                      @keyup="calcularTotalPorTipo">
                    </custom-text-field-green>
                    <custom-text-field-green
                      cols="3"
                      v-model.number="contratoConvenioModificatorio.porcentajeIva"
                      label="% IVA"
                      prefix="%"
                      readonly
                      disabled>
                    </custom-text-field-green>
                    <custom-text-field-green
                      cols="6"
                      v-model.number="contratoConvenioModificatorio.iva"
                      label="Importe IVA"
                      es-dinero
                      prefix="$"
                      readonly
                      disabled>
                    </custom-text-field-green>
                    <custom-text-field-green
                      cols="6"
                      v-model.number="contratoConvenioModificatorio.total"
                      label="Total"
                      es-dinero
                      prefix="$"
                      readonly
                      disabled>
                    </custom-text-field-green>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <custom-text-field
              cols="12"
              v-model="contratoConvenioModificatorio.motivo"
              label="Motivo - Justificación">
            </custom-text-field>
          </v-row>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixActualizarConvenioModificatorio"
            :disabled="!formularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Guardar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import mixConvenioContrato from './mixConvenioContrato';
import CustomTextField from '@/components/inputs/TextField.vue';
import customTextFieldGreen from '@/components/inputs/TextFieldGreen.vue';
import CustomDatePicker from '@/components/inputs/DatePicker.vue';
import CustomSelect from '@/components/inputs/Select.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'EditarContratoConvenioModificatorio',
  mixins: [mixConvenioContrato],
  components: {
    customTextFieldGreen,
    CustomTextField,
    CustomDatePicker,
    CustomSelect,
    CustomButton,
  },
  props: {
    contrato: Object,
    convenioModificatorioEditar: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      contratistaSelected: null,
      formularioValido: false,
      enviandoFormulario: false,
      contratoConvenioModificatorio: {
        // idObra: ID,
        numero: this.convenioModificatorioEditar.numero, // ! String
        fecha: this.convenioModificatorioEditar.fecha, // ! String
        tipo: this.convenioModificatorioEditar.tipo, // ! String
        motivo: this.convenioModificatorioEditar.motivo, // String,
        objeto: this.convenioModificatorioEditar.objeto, // String,
        fechaInicio: new Date(this.convenioModificatorioEditar.fechaInicio)
          .toISOString().substr(0, 10), // String
        fechaTermino: new Date(this.convenioModificatorioEditar.fechaTermino)
          .toISOString().substr(0, 10), // String
        importeCostoDirecto: this.convenioModificatorioEditar.importeCostoDirecto,
        importeCostoIndirectos: this.convenioModificatorioEditar.importeCostoIndirectos,
        importeUtilidad: this.convenioModificatorioEditar.importeUtilidad,
        importeCargosAdicionales: this.convenioModificatorioEditar.importeCargosAdicionales,
        importeCostoFinanciero: this.convenioModificatorioEditar.importeCostoFinanciero,
        importe: this.convenioModificatorioEditar.importe, // Double
        porcentajeIva: this.convenioModificatorioEditar.porcentajeIva, // Int
        iva: this.convenioModificatorioEditar.iva, // Double
        total: this.convenioModificatorioEditar.total, // Double
      },
      tiposConvenios: [
        'PLAZO',
        'REPROGRAMACIÓN',
        'MONTO - AMPLIACIÓN',
        'MONTO - REDUCCIÓN',
        'PLAZO - MONTO AMPLIACIÓN',
        'FINANCIERO',
        'CAMBIO DE META',
      ],
    };
  },
  methods: {
    limpiarFormulario() {
      this.$refs.editarContratoConvenioModificatorio.reset();
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
  },
};
</script>

<style lang="scss">

</style>
